'use client';

import { useRouter } from 'next/navigation';

import { ChevronIcon } from '../icons';

import styles from './BackButton.module.scss';

type BackButtonProps = {
  onClick?: () => void;
};

export function BackButton({ onClick }: BackButtonProps) {
  const router = useRouter();

  return (
    <button
      type="button"
      aria-label="Back button"
      className={`${styles.backButton}`}
      onClick={onClick ?? (() => router.back())}
    >
      <ChevronIcon />
    </button>
  );
}
